var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.appStyle)},[_c('AppBar',{on:{"toggle":function($event){return _vm.toggleAppDrawer(!_vm.isDrawerOpen)}}}),_c('AppDrawer',{attrs:{"isOpen":_vm.isDrawerOpen},on:{"toggle":_vm.toggleAppDrawer}}),_c('v-main',[_c(_vm.contentDrawer,{tag:"component"}),_c('CoreView')],1),_c('SnackBar'),_c('AppDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }